import React, { Component } from 'react'
import { Fragment } from 'react'
import AppURL from '../api/AppURL'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import axios from 'axios'
import SubCategory from '../components/ProductDetails/SubCategory'
import { useParams } from 'react-router-dom';


function ProductSubCategoryPageWrapper(props) {
     // useParams ব্যবহার করে category এবং subcategory প্যারামিটারগুলো পাওয়া হচ্ছে
     const { category, subcategory } = useParams();
     return <ProductSubCategoryPage {...props} category={category} subcategory={subcategory} />;
}


class ProductSubCategoryPage extends Component {
     constructor(props) {
          super(props);
          this.state = {
               Category: props.category,
               SubCategory: props.subcategory,
               ProductData: []
          }
     }


     componentDidMount() {
          window.scroll(0, 0);
          this.loadProductData();
     }


     componentDidUpdate(prevProps) {
          // Check if category or subcategory has changed
          if (prevProps.category !== this.props.category || prevProps.subcategory !== this.props.subcategory) {
               this.setState({
                    Category: this.props.category,
                    SubCategory: this.props.subcategory
               }, () => {
                    this.loadProductData();
               });
          }
     }



     loadProductData = () => {
          axios.get(AppURL.ProductListBySubCategory(this.state.Category, this.state.SubCategory))
               .then(response => {
                    this.setState({ ProductData: response.data });
               })
               .catch(error => {
                    console.error("Error fetching product data:", error);
               });
     }




     // componentDidMount() {
     //      window.scroll(0, 0)
     //      // alert(this.state.Category);
     //      axios.get(AppURL.ProductListBySubCategory(this.state.Category, this.state.SubCategory)).then(response => {

     //           this.setState({ ProductData: response.data });

     //      }).catch(error => {

     //      });

     // }


     render() {
          return (
               <Fragment>
                    <div className="Desktop">
                         <NavMenuDesktop />
                    </div>

                    <div className="Mobile">
                         <NavMenuMobile />
                    </div>

                    <SubCategory Category={this.state.Category} SubCategory={this.state.SubCategory} ProductData={this.state.ProductData} />


                    <div className="Desktop">
                         <FooterDesktop />
                    </div>

                    <div className="Mobile">
                         <FooterMobile />
                    </div>

               </Fragment>
          )
     }
}

export default ProductSubCategoryPageWrapper;
